<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-row :gutter="48">
        <a-col :md="5" :sm="24" v-if="queryParam.title">
          <a-form-item label="标题">
            <a-input v-model="queryParam.title" placeholder @change="$emit('refresh')" />
          </a-form-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="isNeedOrgName">
          <a-form-item label="机构">
            <a-input v-model="queryParam.orgName" placeholder @change="$emit('refresh')" />
          </a-form-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="queryParam.sourceName">
          <a-form-item label="来源">
            <a-input v-model="queryParam.sourceName" placeholder />
          </a-form-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="isQUestionForm">
          <a-form-item label="分组">
            <DictSelector v-model="queryParam.groupId" type="group" @input="$emit('refresh')" />
          </a-form-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="isTelphone">
          <a-form-item label="学员手机号">
            <a-input v-model="queryParam.telphone" placeholder />
          </a-form-item>
        </a-col>
        <a-col :md="5" :sm="24" v-if="isReviewWithdrawal">
          <a-form-item label="状态">
            <dict-selector v-model="queryParam.state" type="reviewWithdrawal" @input="$emit('refresh')" />
          </a-form-item>
        </a-col>
        <!-- <a-col :md="5" :sm="24">
          <a-form-item label="机构">
            <DictSelector v-model="queryParam.ocoedeList" type="ocode" @input="$emit('refresh')" />
          </a-form-item>
        </a-col> -->
        <!-- <a-col :md="5" :sm="24" v-if="queryParam.ocoedeList">
          <a-form-item label="机构">
            <a-select
              style="width: 120px"
              @change="$emit('orcodeInput', $event)"
              :allowClear="true"
              v-for="item in queryParam.ocoedeList"
              :key="item.ocode"
            >
              <a-select-option :value="item.ocode">
                {{ item.orgName }}
              </a-select-option>
            </a-select> -->
        <!-- <DictSelector v-model="queryParam.ocoedeList" type="ocode" @input="$emit('refresh')" /> -->
        <!-- </a-form-item> -->
        <!-- </a-col> -->
        <a-col :md="5" :sm="24" v-if="isNeedState">
          <a-form-item label="状态">
            <DictSelector v-model="queryParam.state" type="state" @input="$emit('refresh')" />
          </a-form-item>
        </a-col>
        <!-- <a-col :md="5" :sm="24" v-if="queryParam.checkType">
          <a-form-item label="状态">
            <DictSelector v-model="queryParam.checkType" type="checkType" @input="$emit('refresh')" />
          </a-form-item>
        </a-col> -->
        <a-col :md="9" :sm="24" v-if="isNeedTime">
          <a-form-item
            :label="createTimeTitle"
            :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
            :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }"
          >
            <a-range-picker
              :placeholder="['开始时间', '结束时间']"
              v-model="rangePickerDefaultValue"
              format="YYYY-MM-DD"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { MetaTag } from '@/components'
import moment from 'moment'
export default {
  components: { MetaTag },
  props: {
    queryParam: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isQUestionForm: {
      type: Boolean,
      default: true
    },
    isNeedState: {
      type: Boolean,
      default: true
    },
    isNeedTime: {
      type: Boolean,
      default: true
    },
    isNeedOrgName: {
      type: Boolean,
      default: false
    },
    createTimeTitle: {
      type: String,
      default: '创建时间'
    },
    isTelphone: {
      type: Boolean,
      default: false
    },
    isReviewWithdrawal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rangePickerDefaultValue: {
      get() {
        let data = []
        if (this.queryParam.startTime && this.queryParam.endTime) {
          data[0] = moment(this.queryParam.startTime, 'YYYY-MM-DD HH:mm:ss')
          data[1] = moment(this.queryParam.endTime, 'YYYY-MM-DD HH:mm:ss')
        } else {
          data = []
        }
        return data
      },
      set(date) {
        if (!date[0] && !date[1]) {
          this.queryParam.startTime = ''
          this.queryParam.endTime = ''
        } else {
          this.$set(this.queryParam, 'startTime', date[0].startOf('day').format('YYYY-MM-DD HH:mm:ss'))
          this.$set(this.queryParam, 'endTime', date[1].endOf('day').format('YYYY-MM-DD HH:mm:ss'))
          this.$emit('refresh')
        }
      }
    }
  },
  methods: {}
}
</script>

<style></style>
